import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { Loader } from "@/components/Loader";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Transformations } from "@/components/Transformations";
import { CarNeeds } from "@/components/CarNeeds";
import { Inspection } from "@/components/Inspection";
import { Services } from "@/components/Services";
import { Difference } from "@/components/Difference";
import { DifferenceProof } from "@/components/DifferenceProof";
import { DetailingTransform } from "@/components/DetailingTransform";
import { Testimonials } from "@/components/Testimonials";
import { Education } from "@/components/Education";
import { Work } from "@/components/Work";
import { About } from "@/components/About";
import { Process } from "@/components/Process";
import { Studio } from "@/components/Studio";
import { Location } from "@/components/Location";
import { FinalOffer } from "@/components/FinalOffer";
import { Enquiry } from "@/components/Enquiry";
import { EmotionalClose } from "@/components/EmotionalClose";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { ScrollProgress } from "@/components/ScrollProgress";
import { OfferPopup } from "@/components/OfferPopup";
import { ChatWidget } from "@/components/ChatWidget";

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setLoading(false), 2500);
        return () => clearTimeout(t);
    }, []);

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ anchors: true, lerp: 0.09 });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <EnquiryProvider>
            <AnimatePresence>{loading && <Loader key="loader" />}</AnimatePresence>
            <ScrollProgress />
            <Nav started={!loading} />
            <main className="pb-14 md:pb-0">
                <Hero started={!loading} />
                <TrustStrip />
                <Transformations />
                <Testimonials />
                <DifferenceProof />
                <CarNeeds />
                <Inspection />
                <Services />
                <Education />
                <DetailingTransform />
                <Difference />
                <About />
                <Process />
                <Work />
                <Studio />
                <Location />
                <FinalOffer />
                <Enquiry />
                <EmotionalClose />
            </main>
            <Footer />
            <MobileActionBar />
            <FloatingWhatsApp />
            <OfferPopup />
            <ChatWidget />
        </EnquiryProvider>
    );
}

export default App;
